// extracted by mini-css-extract-plugin
export var body = "module-body-module--body--3372e";
export var grid = "module-body-module--grid--76943";
export var gridWithRowGap = "module-body-module--grid--with-row-gap--7a338";
export var maxWidthContainer = "module-body-module--max-width-container--552e7";
export var mt0 = "module-body-module--mt-0--69360";
export var mt1 = "module-body-module--mt-1--f4689";
export var mt2 = "module-body-module--mt-2--1d913";
export var mt3 = "module-body-module--mt-3--3ebaa";
export var mt4 = "module-body-module--mt-4--752fc";
export var mt5 = "module-body-module--mt-5--20b03";
export var mt6 = "module-body-module--mt-6--29fad";
export var removeVisuallyHidden = "module-body-module--remove-visually-hidden--f9896";
export var visuallyHidden = "module-body-module--visually-hidden--7cbff";
export var widgetBase = "module-body-module--widget-base--45343";